import React from "react";

import { useTranslation } from "react-i18next";

import Currency from "@components-shared/Currency";
import { Button } from "@components/buttons";
import { defaultTemplate } from "@hoc";
import { useRootAppStore } from "@hooks";
import BetSlipStore from "@state/bet-slip/BetSlipStore";
import { redirectToLogin } from "@utils/auth";

import NumberInput from "./NumberInput";

export default defaultTemplate(function OneClickBet(props: {
	store: BetSlipStore;
}) {
	const { t } = useTranslation();

	const rootStore = useRootAppStore();

	if (!rootStore.userAuthStore.isLoggedIn) {
		return (
			<div className="oneclick">
				<div className="oneclick__title">
					{t("BET_SLIP.ONE_CLICK_BET.NOT_ACTIVE_MESSAGE")}
				</div>
				<i className="u-icon u-icon--huge u-icon--oneclick" />
				<div className="u-type--sml">
					{t("BET_SLIP.ONE_CLICK_BET.DESCRIPTION")}
				</div>
				<Button
					onClick={() => redirectToLogin("isOneClickBet=true")}
					className="btn btn--sml btn--block btn--secondary"
					btnContent={t("BET_SLIP.ONE_CLICK_BET.LOGIN_TO_ACTIVATE")}
				/>
			</div>
		);
	}

	return (
		<div className="oneclick">
			{props.store.isLoading || props.store.isCountdownVisible ? (
				<div className="oneclick__loader">
					<div className="loader--countdown__inner">
						{props.store.isCountdownVisible && (
							<div className="loader--countdown__box loader--countdown__box--sml">
								{props.store.countdownCounter}
							</div>
						)}
						<div className="loader--countdown__title">
							{t<string>("HOME.LOADING")}...
						</div>
					</div>
				</div>
			) : null}

			<div className="oneclick__body">
				<div className="oneclick__amount">
					<label className="oneclick__label label">
						{t<string>("BET_SLIP.ONE_CLICK_BET.CHOOSE_AMOUNT")}
					</label>

					<input
						id="1"
						type="radio"
						name="amount"
						onClick={(e) =>
							props.store.onOneClickBetAmountChange(5)
						}
						className="oneclick__radio"
					/>
					<label htmlFor="1" className="u-mar--right--xtny">
						{t("BET_SLIP.ONE_CLICK_BET.AMOUNT_5")}
						<Currency />
					</label>

					<input
						id="2"
						type="radio"
						name="amount"
						onClick={(e) =>
							props.store.onOneClickBetAmountChange(10)
						}
						className="oneclick__radio"
					/>
					<label htmlFor="2" className="u-mar--right--xtny">
						{t("BET_SLIP.ONE_CLICK_BET.AMOUNT_10")}
						<Currency />
					</label>

					<input
						id="3"
						type="radio"
						name="amount"
						onClick={(e) =>
							props.store.onOneClickBetAmountChange(15)
						}
						className="oneclick__radio"
					/>
					<label htmlFor="3">
						{t<string>("BET_SLIP.ONE_CLICK_BET.AMOUNT_15")}
						<Currency />
					</label>
				</div>
				<div className="oneclick__custom">
					<label
						htmlFor="customValue"
						className="oneclick__label label"
					>
						{t<string>("BET_SLIP.ONE_CLICK_BET.CUSTOM_AMOUNT")}
					</label>
					<div className="oneclick__custom__field">
						<NumberInput
							id="customValue"
							className="oneclick__custom__input input input--sml"
							onChange={(value) =>
								props.store.onOneClickBetAmountChange(value)
							}
							value={props.store.oneClickBetAmount}
						/>
						<span className="oneclick__custom__currency">
							<Currency />
						</span>
					</div>
				</div>
			</div>
		</div>
	);
});
